export const COURSES = ["Medical Coding"];
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_excel-learn-hub-2/artifacts/i2tti92b_image.png";
